import { createAction } from '../../../utils/redux/createAction';

const actionsScope = 'profile/add-data-modal';

export const ADD_DATA_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const addDataModalActions = {
  open: createAction(ADD_DATA_MODAL.OPEN),
  close: createAction(ADD_DATA_MODAL.CLOSE),
};

const initialState = {
  opened: false,
  type: 'weight',
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ADD_DATA_MODAL.OPEN: {
      return {
        ...state,
        opened: true,
        type: payload.type,
      };
    }

    case ADD_DATA_MODAL.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/add-data-modal.js